import {
  ApplicationConfig,
  LOCALE_ID,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';

import {
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import CustomTheme from '../style/vendor/primeng/themes/custom-theme/custom-theme';
import { httpInterceptors } from './core/config/http-interceptors';
import { ConfirmationService, MessageService } from 'primeng/api';
import { CognitoAuthService } from './shared/service/cognito-auth.service';
import { appRoutes } from './app.routes';
import { AUTH_PROVIDER } from './shared/common/injector-token';
import { TranslatePipe } from '@ngx-translate/core';
import { TranslateConfig } from './core/config/translate.config';
import { provideStore, withNgxsNoopExecutionStrategy } from '@ngxs/store';
import {
  ngxsConfig,
  ngxsStates,
  ngxsStorageConfig,
} from './core/config/ngxs.config';
import { withNgxsStoragePlugin } from '@ngxs/storage-plugin';
import { withNgxsRouterPlugin } from '@ngxs/router-plugin';

const globalServices = [
  { provide: AUTH_PROVIDER, useExisting: CognitoAuthService },
  MessageService,
  ConfirmationService,
];

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(appRoutes),
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimationsAsync(),
    TranslateConfig,
    providePrimeNG({
      ripple: false,
      theme: {
        preset: CustomTheme,
        options: {
          prefix: 'p',
          darkModeSelector: '.dark-mode',
          cssLayer: {
            name: 'primeng',
            order:
              'normalize, app-styles, primeng, primeicons, primeflex, custom',
          },
        },
      },
    }),
    provideStore(
      ngxsStates,
      ngxsConfig,
      withNgxsNoopExecutionStrategy(),
      withNgxsStoragePlugin(ngxsStorageConfig),
      withNgxsRouterPlugin()
    ),
    { provide: LOCALE_ID, useValue: 'en-US' },
    ...httpInterceptors,
    ...globalServices,
  ],
};
